import styled from 'styled-components'
import { Flex } from 'grid-styled'

import media from '../../../styles/tools/media'

import { offWhite } from '../../../styles/settings/colors'
import rem from '../../../styles/tools/rem'

export const Separator = styled.hr`
  background-color: ${offWhite};
  border: 0;
  height: ${rem('1px')};
  margin: ${rem('35px')} 0 ${rem('25px')} 0;
`

export const Container = styled(Flex)`
  flex-direction: column;

  ${media.large`
        margin: ${rem('40px')} 0 ${rem('60px')} 0;
        align-sefl: stretch;
        width: 100%;
        flex-direction: row;
    `};
`

export const FinancialInformation = styled(Flex)`
  width: 100%;
  flex-direction: column;

  ${media.large`
        margin-left: ${rem('41px')};
    `};
`



// WEBPACK FOOTER //
// ./src/app/pages/PlanData/styles.js